import ContentTitle from '../../../components/molecules/contentTitle/ContentTitle';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import React from 'react';

const ContentTitleTastic = ({ data, context }) => {
  if (!data) return null;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  return <ContentTitle {...data} />;
};

export default tastify({ translate: true, connect: { context: true } })(ContentTitleTastic);
